module.exports = __webpack_public_path__ + "img/Malaysia.a46790a6.png";